import React from "react";
import { Link } from "gatsby";

const NavLinks = ({ extraClassName }) => {
  const handleDropdownStatus = (e) => {
    let clickedItem = e.currentTarget.parentNode;
    clickedItem.querySelector(".dropdown-list").classList.toggle("show");
  };
  return (
    <ul className={`main-menu__list ${extraClassName}`}>
      <li className="dropdown">
        <Link to="/">Home</Link>
      </li> 
      <li className="dropdown">
      <Link >Who We Are</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/about">About-Us</Link>
          </li>
          <li>
            <Link to="/what-we-do">What We Do</Link>
          </li>
          <li>
            <Link to="/where-we-work">Where We Work</Link>
          </li>
          <li>
            <Link to="/get-involved">Get Involved</Link>
          </li>
          <li>
            <Link to="/quotes">Quotable Quotes</Link>
          </li>
          {/* <li>
            <Link to="impact">Impact stories</Link>
          </li> */}
        </ul>
      </li>
      <li className="dropdown">
        <Link to="/gallery">Gallery</Link>

      </li>
      {/* <li className="dropdown">
        <Link to="/news">News</Link>
        <button aria-label="dropdown toggler" onClick={handleDropdownStatus}>
          <i className="fa fa-angle-down"></i>
        </button>
        <ul className="dropdown-list">
          <li>
            <Link to="/news">News</Link>
          </li>
          <li>
            <Link to="/news-details">News Details</Link>
          </li>
        </ul>
      </li> */}
      <li className="dropdown">
        <Link to="/about">About</Link>
      </li>
      <li>
        <Link to="/become-volunteer">Volunteer</Link>
      </li>
      <li>
        <Link to="/contact">Contact</Link>
      </li>
      <li className="search-btn search-toggler">
        <span>
          <i className="azino-icon-magnifying-glass"></i>
        </span>
      </li>
    </ul>
  );
};

export default NavLinks;
